(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["country-redirector"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class CountryRedirector {
      constructor() {
        this.container = document.querySelector('[data-country-redirector]');
        if (!this.container) return;
        this.closeBtns = this.container.querySelectorAll('[data-cr-close]');
        this.descriptionEl = this.container.querySelector('[data-cr-description]');
        this.ctaEl = this.container.querySelector('[data-cr-cta]');
        this.delay = parseInt(this.container.dataset.delay) || 3;
        this.frequency = this.container.dataset.frequency || 'once_per_day';
        this.storageKey = 'country_redirector_last_shown';
        this.detectedCountry = null;
        this.detectedStore = null;
        this.init();
      }

      init() {
        var self = this;
        this.container.querySelector('.country-redirector__overlay').addEventListener('click', function () {
          self.close();
        });
        this.closeBtns.forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (btn.classList.contains('country-redirector__overlay')) return;
            self.close();
          });
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && self.container.classList.contains('is-open')) {
            self.close();
          }
        });

        this.detectCountry();
      }

      detectCountry() {
        var stores = Array.prototype.map.call(
          this.container.querySelectorAll('[data-store-iso]'),
          function (el) {
            return {
              iso: el.dataset.storeIso,
              name: el.dataset.storeName,
              url: el.dataset.storeUrl
            };
          }
        );
        if (!stores.length) return;

        var currentIso = (this.container.dataset.currentIso || '').toUpperCase();
        var detectedIso = this._detectCountryCode();
        if (!detectedIso || detectedIso === currentIso) return;

        var store = null;
        for (var i = 0; i < stores.length; i += 1) {
          if (stores[i].iso === detectedIso) {
            store = stores[i];
            break;
          }
        }
        if (!store) return;

        this.detectedCountry = store.name;
        this.detectedStore = store;
        var self = this;
        setTimeout(function () { self.checkAndShow(); }, this.delay * 1000);
      }

      // Timezone-only detection: each ALDO group country maps 1:1 to its IANA zone.
      // (window.Shopify.country is the store's own market, not the visitor's —
      // unusable for cross-store detection in the expansion-stores model.)
      _detectCountryCode() {
        var tz = '';
        try {
          if (window.Intl && Intl.DateTimeFormat) {
            tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
          }
        } catch (e) {
          tz = '';
        }
        var map = {
          'America/Tegucigalpa': 'HN',
          'America/Costa_Rica': 'CR',
          'America/Panama': 'PA',
          'America/Bogota': 'CO',
          'America/Santo_Domingo': 'DO'
        };
        return (tz && map[tz]) || '';
      }

      checkAndShow() {
        if (!this.shouldShow()) return;
        if (this.descriptionEl && this.detectedCountry) {
          var tpl = this.descriptionEl.getAttribute('data-cr-template') || '';
          this.descriptionEl.innerHTML = tpl.replace(/\{country\}/g, '<span class="country-redirector__detected">' + this._escHtml(this.detectedCountry) + '</span>');
        }
        if (this.ctaEl) {
          if (this.detectedStore) {
            this.ctaEl.setAttribute('href', this.detectedStore.url);
          }
          var ctaTpl = this.ctaEl.getAttribute('data-cr-template') || '';
          if (this.detectedCountry && ctaTpl.indexOf('{country}') !== -1) {
            this.ctaEl.textContent = ctaTpl.replace(/\{country\}/g, this.detectedCountry);
          }
        }
        this.container.classList.add('is-open');
        this.recordVisit();
      }

      _escHtml(str) {
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
      }

      shouldShow() {
        var lastShown = localStorage.getItem(this.storageKey);
        if (!lastShown) return true;

        var lastShownTime = parseInt(lastShown);
        var now = Date.now();

        switch (this.frequency) {
          case 'every_visit':
            return true;
          case 'once_per_day':
            return (now - lastShownTime) > 24 * 60 * 60 * 1000;
          case 'once_per_week':
            return (now - lastShownTime) > 7 * 24 * 60 * 60 * 1000;
          case 'once_only':
            return false;
          default:
            return true;
        }
      }

      recordVisit() {
        localStorage.setItem(this.storageKey, Date.now().toString());
      }

      close() {
        this.container.classList.remove('is-open');
        this.recordVisit();
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      new CountryRedirector();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
  class GalleryLightbox {
    constructor(section) {
      this.section = section;
      this.lightbox = section.querySelector('.gallery__lightbox');
      this.lightboxImage = section.querySelector('.gallery__lightbox-image');
      this.triggers = section.querySelectorAll('.gallery__lightbox-trigger');
      this.closeBtn = section.querySelector('.gallery__lightbox-close');
      this.prevBtn = section.querySelector('.gallery__lightbox-prev');
      this.nextBtn = section.querySelector('.gallery__lightbox-next');
      this.currentIndex = 0;
      this.images = [];
      
      this.init();
    }
    
    init() {
      this.triggers.forEach((trigger, index) => {
        const img = trigger.querySelector('.gallery__image');
        if (img) {
          this.images.push({
            src: img.src,
            alt: img.alt
          });
        }
        
        trigger.addEventListener('click', () => this.open(index));
      });
      
      this.closeBtn.addEventListener('click', () => this.close());
      this.prevBtn.addEventListener('click', () => this.prev());
      this.nextBtn.addEventListener('click', () => this.next());
      
      this.lightbox.addEventListener('click', (e) => {
        if (e.target === this.lightbox) {
          this.close();
        }
      });
      
      document.addEventListener('keydown', (e) => {
        if (this.lightbox.style.display === 'flex') {
          if (e.key === 'Escape') this.close();
          if (e.key === 'ArrowLeft') this.prev();
          if (e.key === 'ArrowRight') this.next();
        }
      });
    }
    
    open(index) {
      this.currentIndex = index;
      this.updateImage();
      this.lightbox.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
    
    close() {
      this.lightbox.style.display = 'none';
      document.body.style.overflow = '';
    }
    
    prev() {
      this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
      this.updateImage();
    }
    
    next() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
      this.updateImage();
    }
    
    updateImage() {
      const image = this.images[this.currentIndex];
      if (image) {
        this.lightboxImage.src = image.src;
        this.lightboxImage.alt = image.alt;
      }
    }
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.gallery').forEach(section => {
      if (section.querySelector('.gallery__lightbox')) {
        new GalleryLightbox(section);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-center"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('help-center')) return;

    class HelpCenter extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-help-dialog]');
        this.nav = this.querySelector('[data-help-nav]');
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);

        if (this.nav) {
          this.nav.addEventListener('change', function (event) {
            var url = event.target.value;
            if (url) window.location.href = url;
          });
        }

        if (this.dialog) {
          var dialog = this.dialog;
          // Clic en el fondo (fuera del panel) cierra; Esc lo maneja el <dialog> nativo.
          dialog.addEventListener('click', function (event) {
            if (event.target === dialog) dialog.close();
          });
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        if (this.dialog && this.dialog.open) this.dialog.close();
      }

      onClick(event) {
        var trigger = event.target.closest('[data-help-open]');
        if (trigger && this.dialog) {
          var answer = document.getElementById(trigger.dataset.helpOpen);
          var question = trigger.querySelector('.help-faq__question');
          this.dialog.querySelector('[data-help-dialog-title]').textContent = question ? question.textContent : '';
          this.dialog.querySelector('[data-help-dialog-topic]').textContent = trigger.dataset.helpTopic || '';
          this.dialog.querySelector('[data-help-dialog-body]').innerHTML = answer ? answer.innerHTML : '';
          this.dialog.querySelector('.help-dialog__inner').scrollTop = 0;
          if (typeof this.dialog.showModal === 'function') {
            this.dialog.showModal();
          } else {
            this.dialog.setAttribute('open', '');
          }
          return;
        }
        if (event.target.closest('[data-help-close]') && this.dialog) {
          this.dialog.close();
        }
      }
    }

    customElements.define('help-center', HelpCenter);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
class ProductCarousel {
constructor(section) {
this.section = section;
this.track = section.querySelector('.product-carousel__track');
this.prevBtn = section.querySelector('.product-carousel__arrow--prev');
this.nextBtn = section.querySelector('.product-carousel__arrow--next');
this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
this.autoplay = this.track.dataset.autoplay === 'true' && this.canHover;
this.autoplaySpeed = parseInt(this.track.dataset.autoplaySpeed, 10) * 1000;
this.autoplayTimer = null;
this.isTicking = false;

this.init();
}

init() {
this.prevBtn?.addEventListener('click', () => this.scrollByPage(-1));
this.nextBtn?.addEventListener('click', () => this.scrollByPage(1));

// Real scroll-position-based bounds instead of an index tied to a
// hardcoded dot count — this is what let the carousel "get stuck"
// before reaching every product, or show a dot state that didn't
// match how far you could actually scroll.
this.track.addEventListener('scroll', () => {
if (this.isTicking) return;
window.requestAnimationFrame(() => { this.syncArrows(); this.isTicking = false; });
this.isTicking = true;
}, { passive: true });

if (this.autoplay) {
this.startAutoplay();
this.track.addEventListener('mouseenter', () => this.stopAutoplay());
this.track.addEventListener('mouseleave', () => this.startAutoplay());
}

this.syncArrows();
this.initSwatchImageSwap();
}

scrollByPage(dir) {
this.track.scrollBy({ left: Math.sign(dir) * (this.track.clientWidth * 0.9), behavior: 'smooth' });
}

syncArrows() {
const maxScroll = this.track.scrollWidth - this.track.clientWidth;
this.prevBtn?.classList.toggle('is-disabled', this.track.scrollLeft <= 1);
this.nextBtn?.classList.toggle('is-disabled', this.track.scrollLeft >= maxScroll - 1);
}

startAutoplay() {
this.stopAutoplay();
this.autoplayTimer = setInterval(() => {
const maxScroll = this.track.scrollWidth - this.track.clientWidth;
if (this.track.scrollLeft >= maxScroll - 1) {
this.track.scrollTo({ left: 0, behavior: 'smooth' });
} else {
this.scrollByPage(1);
}
}, this.autoplaySpeed);
}

stopAutoplay() {
if (this.autoplayTimer) {
clearInterval(this.autoplayTimer);
this.autoplayTimer = null;
}
}

// Wired to the actual `swatches.liquid` snippet: every swatch span
// that has an image (metafield override, or a variant with its own
// featured_image) carries a `data-image-url` attribute. Swatches with
// no image (plain color swatches with no matching variant photo)
// don't have the attribute and are correctly left alone.
initSwatchImageSwap() {
// mouseenter doesn't bubble, so this listener is attached in the
// capture phase to catch it on the swatch itself as the pointer
// enters — matches "hover to preview" behavior. Guarded to
// hover-capable devices so it doesn't fire from touch taps here;
// click covers touch instead.

this.track.addEventListener('click', (e) => {
const swatch = e.target.closest('.product-card__swatch[data-image-url]');
if (!swatch) return;
e.preventDefault();
this.applySwatchImage(swatch);
});
}

applySwatchImage(swatch) {
const newSrc = swatch.getAttribute('data-image-url');
if (!newSrc) return;
const card = swatch.closest('.product-card--carousel');
const img = card && card.querySelector('.product-card__image--primary');
if (!img || img.src === newSrc) return;
img.src = newSrc;
if (img.srcset) img.removeAttribute('srcset');
card.querySelectorAll('.product-card__swatch.is-active').forEach((s) => s.classList.remove('is-active'));
swatch.classList.add('is-active');
}
}

document.addEventListener('DOMContentLoaded', () => {
document.querySelectorAll('.product-carousel').forEach(section => {
new ProductCarousel(section);
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const RECENTLY_VIEWED_KEY = 'aldo_recently_viewed';
    const MAX_ITEMS = 8;

    class RecentlyViewed {
      constructor() {
        this.container = document.querySelector('[data-recently-viewed]');
        if (!this.container) return;

        this.grid = this.container.querySelector('[data-recently-viewed-container]');
        this.btnPrev = this.container.querySelector('[data-nav-prev]');
        this.btnNext = this.container.querySelector('[data-nav-next]');
        
        this.init();
      }

      async init() {
        this.trackCurrentProduct();
        const viewedHandles = this.getHistory();
        
        if (viewedHandles.length === 0) {
          return;
        }

        const load = async () => {
          try {
            await this.renderProducts(viewedHandles);
            this.container.style.display = 'block';
            this.initCarousel();
          } catch (err) {
            console.error("Recently viewed error:", err);
          }
        };

        // Defer the up-to-8 AJAX calls until the section approaches the viewport,
        // so the PDP's main assets (gallery images, recommendations) don't compete
        // with them during the initial load.
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            if (entries.some((e) => e.isIntersecting)) {
              observer.disconnect();
              load();
            }
          }, { rootMargin: '400px 0px' });
          observer.observe(this.container);
        } else {
          load();
        }
      }

      trackCurrentProduct() {
        const path = window.location.pathname;
        if (!path.includes('/products/')) return;

        const handle = path.split('/products/')[1].split('/')[0];
        let history = this.getHistory();
        
        history = history.filter(h => h !== handle);
        history.unshift(handle);
        
        if (history.length > MAX_ITEMS) history = history.slice(0, MAX_ITEMS);
        
        localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(history));
      }

      getHistory() {
        const stored = localStorage.getItem(RECENTLY_VIEWED_KEY);
        return stored ? JSON.parse(stored) : [];
      }

      async renderProducts(handles) {
        const promises = handles.map(async (handle) => {
          const res = await fetch(`/products/${handle}?section=recently-viewed-card`);
          if (!res.ok) return null;
          const html = await res.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          return doc.querySelector('[data-product-card]')?.outerHTML || null;
        });

        const results = await Promise.all(promises);
        const validCards = results.filter(card => card !== null);

        if (validCards.length > 0) {
          this.grid.innerHTML = validCards.join('');
        } else {
          throw new Error('No valid products found');
        }
      }

      initCarousel() {
        this.btnPrev?.addEventListener('click', () => {
          this.grid.scrollBy({ left: -this.grid.offsetWidth * 0.8, behavior: 'smooth' });
        });

        this.btnNext?.addEventListener('click', () => {
          this.grid.scrollBy({ left: this.grid.offsetWidth * 0.8, behavior: 'smooth' });
        });
      }
    }

    if (!window.aldoRecentlyViewedInitialized) {
      document.addEventListener('DOMContentLoaded', () => {
        new RecentlyViewed();
        window.aldoRecentlyViewedInitialized = true;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('store-locator')) return;

    var normalize = function (value) {
      return (value || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
    };

    class StoreLocator extends HTMLElement {
      connectedCallback() {
        this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-store-card]'));
        if (!this.cards.length) return;
        this.frame = this.querySelector('[data-store-map-frame]');
        this.mapBox = this.querySelector('[data-store-map]');
        this.search = this.querySelector('[data-store-search]');
        this.city = this.querySelector('[data-store-city]');
        this.count = this.querySelector('[data-store-count]');
        this.empty = this.querySelector('[data-store-empty]');
        this.reset = this.querySelector('[data-store-reset]');
        this.cards.forEach(function (card) {
          card._search = normalize(card.dataset.search);
        });

        this.onChange = this.onChange.bind(this);
        this.addEventListener('change', this.onChange);

        var self = this;
        var timer;
        if (this.search) {
          this.search.addEventListener('input', function () {
            clearTimeout(timer);
            timer = setTimeout(function () { self.applyFilter(); }, 200);
          });
        }
        if (this.reset) {
          this.reset.addEventListener('click', function () {
            if (self.search) self.search.value = '';
            if (self.city) self.city.value = '';
            self.applyFilter();
            if (self.search) self.search.focus();
          });
        }
        if (this.frame) {
          this.frame.addEventListener('load', function () {
            self.frame.classList.remove('is-loading');
          });
        }
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
      }

      onChange(event) {
        var target = event.target;
        if (target.classList.contains('store-card__radio')) {
          this.select(target.closest('[data-store-card]'), true);
        } else if (target === this.city) {
          this.applyFilter();
        }
      }

      select(card, fromUser) {
        if (!card) return;
        this.cards.forEach(function (c) {
          c.classList.toggle('is-selected', c === card);
        });
        var radio = card.querySelector('.store-card__radio');
        if (radio && !radio.checked) radio.checked = true;
        if (!this.frame) return;
        var src = card.dataset.embed;
        if (src && this.frame.getAttribute('src') !== src) {
          this.frame.classList.add('is-loading');
          this.frame.setAttribute('src', src);
          var tpl = this.frame.dataset.titleTemplate || '';
          this.frame.setAttribute('title', tpl.replace('[store]', card.dataset.name || ''));
        }
        // Móvil: el mapa está arriba de la lista; si quedó fuera de vista, se
        // desplaza hasta él (scroll, no cambia el layout).
        if (fromUser && this.mapBox && window.matchMedia('(max-width: 767px)').matches) {
          var rect = this.mapBox.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > window.innerHeight) {
            this.mapBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      }

      applyFilter() {
        var query = normalize(this.search ? this.search.value : '');
        var city = this.city ? this.city.value : '';
        var visible = [];
        this.cards.forEach(function (card) {
          var match = (!city || card.dataset.city === city) && (!query || card._search.indexOf(query) !== -1);
          card.hidden = !match;
          if (match) visible.push(card);
        });
        if (this.empty) this.empty.hidden = visible.length > 0;
        if (this.count) {
          // Plantillas renderizadas por Liquid con count 1 y 99 (plural "other" en es/en/fr/de).
          var lang = document.documentElement.lang || 'es';
          var one = false;
          try { one = new Intl.PluralRules(lang).select(visible.length) === 'one'; } catch (e) { one = visible.length === 1; }
          this.count.textContent = one
            ? (this.count.dataset.countOne || '').replace('1', visible.length)
            : (this.count.dataset.countOther || '').replace('99', visible.length);
        }
        var selected = this.querySelector('[data-store-card].is-selected');
        if (visible.length && (!selected || selected.hidden)) this.select(visible[0], false);
      }
    }

    customElements.define('store-locator', StoreLocator);
  })();

  } catch(e) { console.error(e); }
})();
})();
